module.exports = __webpack_public_path__ + "static/img/1.ff5e0540.png";